<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-btn v-if="inEditMode && airport.id != 0" class="ml-2 mr-2" color="primary" @click="saveClick(false)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
                </v-btn>
                <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="saveClick(true)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.saveAndExit') }}
                </v-btn>
                <v-btn v-if="!inEditMode" class="ml-2 mr-2" color="primary" @click="editClick()">
                    <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                </v-btn>
                <v-btn class="mr-2" @click="backClick">
                    <v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" xl="3" lg="4" md="6">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row dense wrap>
                            <v-col cols="12">
                                <CheckBox
                                    :readonly="!inEditMode"
                                    v-model="airport.active"
                                    :label="$t('fields.active')"
                                ></CheckBox>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :maxlength="100"
                                    :readonly="!inEditMode"
                                    v-model="airport.name"
                                    :errorBorder="!airportValidation.name"
                                    :label="'* ' + $t('fields.name')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :maxlength="5"
                                    :readonly="!inEditMode"
                                    v-model="airport.iata_code"
                                    :errorBorder="!airportValidation.iata_code"
                                    :label="'* ' + $t('fields.iataCode')"
                                ></InputField>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import CheckBox from './trinkets/CheckBox';
import InputField from './trinkets/InputField';
import Airport from '../models/Airport';

export default {
    name: 'Airport',
    components: {CheckBox, InputField},
    data: function () {
        return {
            airport: new Airport({id: this.$route.params.id}),
            airportValidation: new Airport({}, true),
            initialLoad: false,
            inEditMode: false,
            lockKey: 'airport',
            lockTimer: null,
        };
    },
    methods: {
        editClick() {
            let vm = this;
            this.$setLock(this, this.lockKey + '|' + this.airport.id, (data) => {
                if (data.success) {
                    vm.inEditMode = true;
                    vm.lockTimer = setInterval(() => {
                        vm.$setLock(vm, vm.lockKey + '|' + vm.airport.id);
                    }, 10000);
                } else {
                    vm.$alert(
                        this.$t('alerts.recordLocked')
                            .split('%name%')
                            .join(data.locked_by.first_name + ' ' + data.locked_by.last_name),
                    );
                }
            });
        },

        backClick() {
            this.$router.go(-1);
        },
        saveClick(goBack) {
            let success = true;
            if (this.airport.name == '') {
                success = false;
                this.airportValidation.name = false;
            } else {
                this.airportValidation.name = true;
            }
            if (this.airport.iata_code == '') {
                success = false;
                this.airportValidation.iata_code = false;
            } else {
                this.airportValidation.iata_code = true;
            }

            if (success) {
                let vm = this;
                let action = 'post';
                let addition = '';
                if (vm.airport.id != 0) {
                    action = 'put';
                    addition = '/' + vm.airport.id;
                }
                this.$APICall(action, 'airports' + addition, this.airport, (data, success) => {
                    if (success) {
                        vm.inEditMode = false;
                        if (vm.airport.id == 0) {
                            vm.$notify(vm.$t('alerts.basicAdd'));
                        } else {
                            vm.$notify(vm.$t('alerts.basicUpdate'));
                        }
                        if (this.lockTimer !== null) clearInterval(this.lockTimer);
                        vm.$removeLock(vm, vm.lockKey + '|' + vm.airport.id);
                        vm.$triggerReload();
                        if (goBack) {
                            vm.backClick();
                        }
                    } else {
                        if (Object.hasOwn(data, 'custom')) {
                            vm.$alert(data.message);
                        } else {
                            vm.$alert(vm.$t('alerts.basicError'));
                        }
                    }
                });
            }
        },
    },

    watch: {
        'airport.iata_code': {
            handler: function () {
                this.airport.iata_code = this.airport.iata_code.toUpperCase();
            },
            deep: true,
        },
    },
    beforeRouteLeave(to, from, next) {
        let vm = this;
        if (this.inEditMode) {
            this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                if (result) {
                    if (vm.lockTimer !== null) clearInterval(this.lockTimer);
                    this.$removeLock(this, this.lockKey + '|' + this.airport.id);
                    next(true);
                } else {
                    next(false);
                }
            });
        } else {
            next(true);
        }
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        let vm = this;
        if (this.airport.id != 0) {
            this.$APICall('get', 'airports/' + this.airport.id, {}, (data, success) => {
                if (success) {
                    let usableData = JSON.parse(JSON.stringify(data));
                    vm.airport = usableData;
                    vm.$myStore.commit('setBreadcrumbs', [
                        {
                            text: vm.$t('modules.airports'),
                            href: '/#/airports',
                            disabled: false,
                        },
                        {
                            text: vm.airport.name,
                            href: '/#/airports/' + vm.airport.id,
                            disabled: true,
                        },
                    ]);
                    vm.$nextTick(() => {
                        vm.initialLoad = true;
                    });
                }
            });
        } else {
            this.$myStore.commit('setBreadcrumbs', [
                {
                    text: this.$t('modules.airports'),
                    href: '/#/airports',
                    disabled: false,
                },
                {
                    text: this.$t('modules.newAirport'),
                    href: '/#/airport/0',
                    disabled: true,
                },
            ]);
            this.inEditMode = true;
            this.initialLoad = true;
        }
    },
};
</script>

<style scoped></style>
